<div class="dialog-box">
  <div class="dialog-box__header">
    <button mat-icon-button mat-dialog-close tabindex="-1">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>
  <div class="dialog-box__content">
    @if (language === LANGUAGES.de) {
      <div class="payment-cancellation">
        <h1 class="payment-cancellation__title payment-cancellation__title--main is-bold">Widerrufsbelehrung für Verbraucher bei Fernabsatzverträgen</h1>
        <div class="payment-cancellation__stage">
          <h2 class="payment-cancellation__title is-bold">Widerrufsbelehrung f&uuml;r Verbraucher</h2>
          <h3 class="payment-cancellation__subtitle is-bold">Widerrufsrecht</h3><br>
          <p class="payment-cancellation__content">
            Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gr&uuml;nden den Vertrag zu widerrufen.<br><br>
            Die Widerrufsfrist betr&auml;gt vierzehn Tage ab dem Tag des Vertragsschlusses.<br><br>
            Um Ihr Widerrufsrecht auszu&uuml;ben, m&uuml;ssen Sie uns<br><br>
            ETX Niecko Legal Rechtsanwaltsgesellschaft mbH<br>
            Potsdamer Str. 62<br>
            14513 Teltow<br>
            office&#64;etxlegal.de<br><br>
            mittels einer eindeutigen Erkl&auml;rung (z. B. ein mit der Post versandter Brief oder eine E-Mail) &uuml;ber Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie k&ouml;nnen daf&uuml;r das beigef&uuml;gte Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.<br><br>
            Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung &uuml;ber die Aus&uuml;bung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
          </p>

          <h3 class="payment-cancellation__subtitle is-bold">Folgen des Widerrufs</h3><br>
          <p class="payment-cancellation__content">
            Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, unverz&uuml;glich und sp&auml;testens binnen vierzehn Tagen ab dem Tag zur&uuml;ckzuzahlen, an dem die Mitteilung &uuml;ber Ihren Widerruf dieses Vertrags bei uns eingegangen ist. F&uuml;r diese R&uuml;ckzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der urspr&uuml;nglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdr&uuml;cklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser R&uuml;ckzahlung Entgelte berechnet.
          </p>

          <div class="payment-cancellation__separator"></div>

          <h2 class="payment-cancellation__title is-bold">Widerrufsformular f&uuml;r Verbraucher</h2>
          <p class="payment-cancellation__content">
            <br>
            <span class="is-italic">(Wenn Sie den Vertrag widerrufen wollen, dann f&uuml;llen Sie bitte dieses Formular aus und senden Sie es zur&uuml;ck.)</span><br><br>
            An:<br>
            ETX Niecko Legal Rechtsanwaltsgesellschaft mbH<br>
            Potsdamer Str. 62<br>
            14513 Teltow<br>
            office&#64;etxlegal.de<br><br>
            Hiermit widerrufe ich den von mir abgeschlossenen Vertrag &uuml;ber die Erbringung der Hilfeleistung in Steuersachen<br><br>
            - Name des/der Verbraucher(s)<br>
            - Anschrift des/der Verbraucher(s)<br>
            - Unterschrift des/der Verbraucher(s) und Datum (nur bei Mitteilung auf Papier)
          </p>
        </div>
      </div>
    }

    @if (language === LANGUAGES.en) {
      <div class="payment-cancellation">
        <h1 class="payment-cancellation__title payment-cancellation__title--main is-bold">Widerrufsbelehrung für Verbraucher bei Fernabsatzverträgen</h1>
        <div class="payment-cancellation__stage">
          <h2 class="payment-cancellation__title is-bold">Widerrufsbelehrung f&uuml;r Verbraucher</h2>
          <h3 class="payment-cancellation__subtitle is-bold">Widerrufsrecht</h3><br>
          <p class="payment-cancellation__content">
            Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gr&uuml;nden den Vertrag zu widerrufen.<br><br>
            Die Widerrufsfrist betr&auml;gt vierzehn Tage ab dem Tag des Vertragsschlusses.<br><br>
            Um Ihr Widerrufsrecht auszu&uuml;ben, m&uuml;ssen Sie uns<br><br>
            ETX Niecko Legal Rechtsanwaltsgesellschaft mbH<br>
            Potsdamer Str. 62<br>
            14513 Teltow<br>
            office&#64;etxlegal.de<br><br>
            mittels einer eindeutigen Erkl&auml;rung (z. B. ein mit der Post versandter Brief oder eine E-Mail) &uuml;ber Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie k&ouml;nnen daf&uuml;r das beigef&uuml;gte Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.<br><br>
            Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung &uuml;ber die Aus&uuml;bung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
          </p>

          <h3 class="payment-cancellation__subtitle is-bold">Folgen des Widerrufs</h3><br>
          <p class="payment-cancellation__content">
            Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, unverz&uuml;glich und sp&auml;testens binnen vierzehn Tagen ab dem Tag zur&uuml;ckzuzahlen, an dem die Mitteilung &uuml;ber Ihren Widerruf dieses Vertrags bei uns eingegangen ist. F&uuml;r diese R&uuml;ckzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der urspr&uuml;nglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdr&uuml;cklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser R&uuml;ckzahlung Entgelte berechnet.
          </p>

          <div class="payment-cancellation__separator"></div>

          <h2 class="payment-cancellation__title is-bold">Widerrufsformular f&uuml;r Verbraucher</h2>
          <p class="payment-cancellation__content">
            <br>
            <span class="is-italic">(Wenn Sie den Vertrag widerrufen wollen, dann f&uuml;llen Sie bitte dieses Formular aus und senden Sie es zur&uuml;ck.)</span><br><br>
            An:<br>
            ETX Niecko Legal Rechtsanwaltsgesellschaft mbH<br>
            Potsdamer Str. 62<br>
            14513 Teltow<br>
            office&#64;etxlegal.de<br><br>
            Hiermit widerrufe ich den von mir abgeschlossenen Vertrag &uuml;ber die Erbringung der Hilfeleistung in Steuersachen<br><br>
            - Name des/der Verbraucher(s)<br>
            - Anschrift des/der Verbraucher(s)<br>
            - Unterschrift des/der Verbraucher(s) und Datum (nur bei Mitteilung auf Papier)
          </p>
        </div>
      </div>
    }

    @if (language === LANGUAGES.pl) {
      <div class="payment-cancellation">
        <h1 class="payment-cancellation__title payment-cancellation__title--main is-bold">Widerrufsbelehrung für Verbraucher bei Fernabsatzverträgen</h1>
        <div class="payment-cancellation__stage">
          <h2 class="payment-cancellation__title is-bold">Widerrufsbelehrung f&uuml;r Verbraucher</h2>
          <h3 class="payment-cancellation__subtitle is-bold">Widerrufsrecht</h3><br>
          <p class="payment-cancellation__content">
            Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gr&uuml;nden den Vertrag zu widerrufen.<br><br>
            Die Widerrufsfrist betr&auml;gt vierzehn Tage ab dem Tag des Vertragsschlusses.<br><br>
            Um Ihr Widerrufsrecht auszu&uuml;ben, m&uuml;ssen Sie uns<br><br>
            ETX Niecko Legal Rechtsanwaltsgesellschaft mbH<br>
            Potsdamer Str. 62<br>
            14513 Teltow<br>
            office&#64;etxlegal.de<br><br>
            mittels einer eindeutigen Erkl&auml;rung (z. B. ein mit der Post versandter Brief oder eine E-Mail) &uuml;ber Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie k&ouml;nnen daf&uuml;r das beigef&uuml;gte Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.<br><br>
            Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung &uuml;ber die Aus&uuml;bung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
          </p>

          <h3 class="payment-cancellation__subtitle is-bold">Folgen des Widerrufs</h3><br>
          <p class="payment-cancellation__content">
            Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, unverz&uuml;glich und sp&auml;testens binnen vierzehn Tagen ab dem Tag zur&uuml;ckzuzahlen, an dem die Mitteilung &uuml;ber Ihren Widerruf dieses Vertrags bei uns eingegangen ist. F&uuml;r diese R&uuml;ckzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der urspr&uuml;nglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdr&uuml;cklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser R&uuml;ckzahlung Entgelte berechnet.
          </p>

          <div class="payment-cancellation__separator"></div>

          <h2 class="payment-cancellation__title is-bold">Widerrufsformular f&uuml;r Verbraucher</h2>
          <p class="payment-cancellation__content">
            <br>
            <span class="is-italic">(Wenn Sie den Vertrag widerrufen wollen, dann f&uuml;llen Sie bitte dieses Formular aus und senden Sie es zur&uuml;ck.)</span><br><br>
            An:<br>
            ETX Niecko Legal Rechtsanwaltsgesellschaft mbH<br>
            Potsdamer Str. 62<br>
            14513 Teltow<br>
            office&#64;etxlegal.de<br><br>
            Hiermit widerrufe ich den von mir abgeschlossenen Vertrag &uuml;ber die Erbringung der Hilfeleistung in Steuersachen<br><br>
            - Name des/der Verbraucher(s)<br>
            - Anschrift des/der Verbraucher(s)<br>
            - Unterschrift des/der Verbraucher(s) und Datum (nur bei Mitteilung auf Papier)
          </p>
        </div>
      </div>
    }
  </div>
</div>
